import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap'
import styled from 'styled-components'
import { buttonClose } from '../helper/button'

export const DiscardProjectForm = (props) => {
  const { open } = props
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => props.toggle() }
      >
        <HeaderForm toggle={ () => props.toggle() }>
          <HeadLabel>Cancel Project Information Form</HeadLabel>
        </HeaderForm>
        <ModalBody>
          Are you sure you want to discard all changes ?
        </ModalBody>
        <ModalFooter>
          { buttonClose(() => props.hideForm(), (type) => props.toggle(type)) }
        </ModalFooter>
      </Modal>
    </div>
  )
}

DiscardProjectForm.propTypes = {
  hideForm: PropTypes.func,
  toggle: PropTypes.func,
  open: PropTypes.bool,
}
DiscardProjectForm.defaultProps = {
  hideForm: () => {},
  toggle: () => {},
  open: false,
}

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`



// WEBPACK FOOTER //
// ./src/components/project-information/form/discard-project.js.js